import { getAccountTradingHistory } from "../../utils/apiClient";
import AppConstants from "../../utils/appConstants";
import { toApiDateParam } from "../../utils/dateRangeApiFormat";

class AccountHistoryController {
  static async getHistory({
    tradingId,
    page = 1,
    perPage = 10,
    dateFrom = null,
    dateTo = null,
    search = null,
  } = {}) {
    const response = await getAccountTradingHistory({
      tradingId,
      page,
      perPage,
      dateFrom: toApiDateParam(dateFrom, false),
      dateTo: toApiDateParam(dateTo, true),
      search: search ? String(search).trim() : null,
    });

    const payload = response?.decryptedData || response?.data || {};
    const code = Number(payload.CODE ?? payload.code);
    if (code !== AppConstants.responseOk) {
      const msg =
        payload.MESSAGE ||
        payload.message ||
        payload.MESSAGES ||
        `API Error (CODE: ${code || "Unknown"})`;
      const error = new Error(typeof msg === "string" ? msg : "Failed to load account history");
      error.code = code;
      throw error;
    }

    const dataBlock = payload.DATA || payload.data || {};
    const list = Array.isArray(dataBlock.data)
      ? dataBlock.data
      : Array.isArray(dataBlock.DATA)
      ? dataBlock.DATA
      : [];

    const items = list.map((item) => ({
      id: item.DEAL_ID ?? item.deal_id ?? item.POSITION_ID ?? item.position_id ?? null,
      symbol: item.SYMBOL ?? item.symbol ?? "",
      type: String(item.TYPE ?? item.type ?? "").toUpperCase() === "SELL" ? "SELL" : "BUY",
      volume: Number(item.VOLUME ?? item.volume ?? 0),
      openPrice: Number(item.OPEN_PRICE ?? item.open_price ?? 0),
      closePrice: Number(item.CLOSE_PRICE ?? item.close_price ?? 0),
      takeProfit: Number(item.TAKE_PROFIT ?? item.take_profit ?? 0),
      stopLoss: Number(item.STOP_LOSS ?? item.stop_loss ?? 0),
      charges: Number(item.CHARGES ?? item.charges ?? 0),
      closeTimestamp: Number(
        item.CLOSE_TIMESTAMP ?? item.close_timestamp ?? item.Time ?? 0
      ) || null,
      closeTime:
        item.CLOSE_TIME ??
        item.close_time ??
        item.EXECUTION_TIME ??
        item.execution_time ??
        null,
      profit: Number(item.PROFIT ?? item.profit ?? 0),
      digits: Number(item.DIGITS ?? item.digits ?? 5),
    }));

    return {
      items,
      pagination: {
        page: Number(dataBlock.current_page ?? page) || 1,
        perPage: Number(dataBlock.per_page ?? perPage) || perPage,
        total: Number(dataBlock.total ?? items.length) || 0,
        lastPage: Number(dataBlock.last_page ?? 1) || 1,
      },
    };
  }
}

export default AccountHistoryController;
